import React from "react";
import "./blog.css";
import { advertisment, advertismentHeader } from "../../data/advertisment";
import {
  creativeDesign,
  creativeDesignHeader,
} from "../../data/creativeDesign";
import { marketing, marketingHeader } from "../../data/digitalMarketing";
import { allBlogs, allBlogsHeader } from "../../data/allBlogs";
import { Link } from "react-router-dom";

const Blog = () => {
  return (
    <section className="blog page">
      <div className="blog-container">
        <div className="tabs-container">
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-home"
                type="button"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                All
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-profile"
                type="button"
                role="tab"
                aria-controls="pills-profile"
                aria-selected="false"
              >
                Digital Marketing
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-webDesign-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-webDesign"
                type="button"
                role="tab"
                aria-controls="pills-webDesign"
                aria-selected="false"
              >
                Creative Design
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-disabled-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-disabled"
                type="button"
                role="tab"
                aria-controls="pills-disabled"
                aria-selected="false"
              >
                Advertisement
              </button>
            </li>
          </ul>
        </div>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
            tabIndex="0"
          >
            <div className="allBlogsHeader blogs-headline">
              {allBlogsHeader && allBlogsHeader.length > 0 ? (
                allBlogsHeader.map((blog) => (
                  <div className="" key={blog.id}>
                    <div className="project">
                      <div className="blogInfo">
                        <h1>
                          {blog.blogTitle
                            .split("UI/UX")
                            .map((part, index, array) => (
                              <React.Fragment key={index}>
                                {part}
                                {index < array.length - 1 && <span>UI/UX</span>}
                              </React.Fragment>
                            ))}
                        </h1>
                        <p>{blog.blogDate}</p>
                      </div>
                      <div className="projectImage">
                        <img src={blog.blogImage} alt="" />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="empty">No Blogs Yet !</p>
                </div>
              )}
            </div>
            <div className="allBlogs-container blogs">
              {allBlogs && allBlogs.length > 0 ? (
                allBlogs.map((blog) => (
                  <div className="" key={blog.id}>
                    <div className="blog-card">
                      <Link to={`/blog/${blog.id}`}>
                        <div className="blogImage">
                          <img src={blog.blogImage} alt="" />
                        </div>
                        <div className="blog-card-Info">
                          <h5>{blog.blogTitle}</h5>
                          <p>{blog.blogDate}</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="empty">No Blogs Yet !</p>
                </div>
              )}
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
            tabIndex="0"
          >
            <div className="marketingHeader blogs-headline">
              {marketingHeader && marketingHeader.length > 0 ? (
                marketingHeader.map((blog) => (
                  <div className="" key={blog.id}>
                    <div className="project">
                      <div className="blogInfo">
                        <h1>
                          {blog.blogTitle
                            .split("Strategies")
                            .map((part, index, array) => (
                              <React.Fragment key={index}>
                                {part}
                                {index < array.length - 1 && (
                                  <span>Strategies</span>
                                )}
                              </React.Fragment>
                            ))}
                        </h1>
                        <p>{blog.blogDate}</p>
                      </div>
                      <div className="projectImage">
                        <img src={blog.blogImage} alt="" />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="empty">No Blogs Yet !</p>
                </div>
              )}
            </div>
            <div className="marketing-container blogs">
              {marketing && marketing.length > 0 ? (
                marketing.map((marketing) => (
                  <div className="" key={marketing.id}>
                    <div className="blog-card">
                      <Link to={`/blog/${marketing.id}`}>
                        <div className="blogImage">
                          <img src={marketing.blogImage} alt="" />
                        </div>
                        <div className="blog-card-Info">
                          <h5>{marketing.blogTitle}</h5>
                          <p>{marketing.blogDate}</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="empty">No marketing Yet !</p>
                </div>
              )}
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="pills-webDesign"
            role="tabpanel"
            aria-labelledby="pills-webDesign-tab"
            tabIndex="0"
          >
            <div className="creativeDesignHeader blogs-headline">
              {creativeDesignHeader && creativeDesignHeader.length > 0 ? (
                creativeDesignHeader.map((blog) => (
                  <div className="" key={blog.id}>
                    <div className="project">
                      <div className="blogInfo">
                        <h1>
                          {blog.blogTitle
                            .split("Strategies")
                            .map((part, index, array) => (
                              <React.Fragment key={index}>
                                {part}
                                {index < array.length - 1 && (
                                  <span>Strategies</span>
                                )}
                              </React.Fragment>
                            ))}
                        </h1>
                        <p>{blog.blogDate}</p>
                      </div>
                      <div className="projectImage">
                        <img src={blog.blogImage} alt="" />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="empty">No Blogs Yet !</p>
                </div>
              )}
            </div>
            <div className="creativeDesign-container blogs">
              {creativeDesign && creativeDesign.length > 0 ? (
                creativeDesign.map((design) => (
                  <div className="" key={design.id}>
                    <div className="blog-card">
                      <Link to={`/blog/${design.id}`}>
                        <div className="blogImage">
                          <img src={design.blogImage} alt="" />
                        </div>
                        <div className="blog-card-Info">
                          <h5>{design.blogTitle}</h5>
                          <p>{design.blogDate}</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="empty">No creative Design Yet !</p>
                </div>
              )}
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="pills-disabled"
            role="tabpanel"
            aria-labelledby="pills-contact-tab"
            tabIndex="0"
          >
            <div className="advertismentHeader blogs-headline">
              {advertismentHeader && advertismentHeader.length > 0 ? (
                advertismentHeader.map((blog) => (
                  <div className="" key={blog.id}>
                    <div className="project">
                      <div className="blogInfo">
                        <h1>
                          {blog.blogTitle
                            .split("Strategies")
                            .map((part, index, array) => (
                              <React.Fragment key={index}>
                                {part}
                                {index < array.length - 1 && (
                                  <span>Strategies</span>
                                )}
                              </React.Fragment>
                            ))}
                        </h1>
                        <p>{blog.blogDate}</p>
                      </div>
                      <div className="projectImage">
                        <img src={blog.blogImage} alt="" />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="empty">No Blogs Yet !</p>
                </div>
              )}
            </div>
            <div className="ads-container blogs">
              {advertisment && advertisment.length > 0 ? (
                advertisment.map((ads) => (
                  <div className="" key={ads.id}>
                    <div className="blog-card">
                      <Link to={`/blog/${ads.id}`}>
                        <div className="blogImage">
                          <img src={ads.blogImage} alt="" />
                        </div>
                        <div className="blog-card-Info">
                          <h5>{ads.blogTitle}</h5>
                          <p>{ads.blogDate}</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="empty">No Works Yet !</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
